module.exports = __webpack_public_path__ + "img/8.433c2bf8.jpg";